<template>
    <v-ons-page>
        <div class="container container--narrow">
            <h1>{{ profile.firstname }} {{ profile.lastname }}</h1>
        </div>
        <v-ons-list modifier="noborder" class="form">
            <v-ons-list-item modifier="nodivider">
                <label for="firstname">
                    First name
                </label>
                <v-ons-input
                    placeholder=""
                    input-id="firstname"
                    v-model="profile.firstname">
                </v-ons-input>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
                <label for="lastname">
                    Last name
                </label>
                <v-ons-input
                    placeholder=""
                    input-id="lastname"
                    v-model="profile.lastname">
                </v-ons-input>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
                <label for="email">
                    Email
                </label>
                <v-ons-input
                    placeholder=""
                    type="email"
                    input-id="email"
                    v-model="profile.email">
                </v-ons-input>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
                <label for="phone">
                    Phone
                </label>
                <v-ons-input
                    placeholder=""
                    input-id="phone"
                    type="number"
                    v-model="profile.phone">
                </v-ons-input>
            </v-ons-list-item>
            <v-ons-list-item modifier="nodivider">
                <label for="mobile">
                    Mobile
                </label>
                <v-ons-input
                    placeholder=""
                    input-id="mobile"
                    type="number"
                    v-model="profile.mobile">
                </v-ons-input>
            </v-ons-list-item>

            <v-ons-list-item modifier="nodivider" class="form-buttons">
                <v-ons-button @click="saveAccount"
                    class="button button--primary">
                    Save
                </v-ons-button>
                 <v-ons-button
                    @click="$router.push({ name: 'home' })"
                    modifier="cta">
                    Cancel
                </v-ons-button>
            </v-ons-list-item>

            <v-ons-list-item>
                <v-ons-button @click="() => showRemoveModal = true"
                    class="button button--danger">
                    Remove my account
                </v-ons-button>
            </v-ons-list-item>
            <v-ons-alert-dialog
                modifier="rowfooter"
                :visible.sync="showRemoveModal"
                >
                <span slot="title">Are you sure you want to remove your account?
                    <br><br>This will delete your account record permanently.</span>
                <template slot="footer">
                    <v-ons-alert-dialog-button @click="showRemoveModal = false">No</v-ons-alert-dialog-button>
                    <v-ons-alert-dialog-button @click="removeAccount">Yes</v-ons-alert-dialog-button>
                </template>
            </v-ons-alert-dialog>
        </v-ons-list>
    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'

export default {
    data() {
        return {
            profile: {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                mobile: '',
            },
            showRemoveModal: false,
        }
    },

    created() {
        this.$emit('init', {
            name: 'profile',
            title: 'User Profile',
            showMenu: true,
        })

        if (!this.customer.content.id) {
            return this.$router.push('login')
        }

        this.profile = _.get(this.login, 'content.attributes', this.profile)
    },

    mixins: [
        Utils,
        Module('login'),
        Module('customer'),
    ],

    methods: {
        saveAccount() {
            this.login.changePath('/my/profile');
            this.login.updateData({
                data: this.profile
            }).then(() => {
                this.notification_push({
                    type: 'success',
                    message: 'Your profile has been updated',
                })
            }).catch(() => {
                this.notification_push({
                    type: 'error',
                    message: 'Cannot update your profile',
                })
            })
        },
        removeAccount() {
            this.login.changePath('/my/profile');
            this.login.deleteData()
            .then(() => {
                this.notification_push({
                    type: 'success',
                    message: 'Your account has been removed',
                })

                this.$emit('logout');
                this.login.setContent({})
                this.customer.setContent({})
                document.body.classList.remove('theme-gold')
                document.body.classList.remove('theme-jade')

            }).catch(() => {
                this.notification_push({
                    type: 'error',
                    message: 'Cannot remove your account',
                })
            })
        },
    }
};
</script>

<style scoped>
/* .right-icon {
  margin-left: 10px;
}
.right-label {
  color: #666;
} */
ons-input {
    width: 100%;
}
.float-right {
    float: right;
}
.list-item{
    padding: 0 14px;
    padding-top: 0;
    padding-bottom: 0;
}
.form-buttons{
    margin-top: 16px;
}
.button--danger {
    margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfilePage.vue